<!-- prettier-ignore -->

<div class="chat__form-wrapper">

  <form #form [formGroup]="chatForm" class="chat__form" (ngSubmit)="handleSubmit()">
    <canvas #waveformCanvas [width]="getCanvasWidth(form)" style="margin: 0 auto;" height="30" [ngClass]="{'d-none': !isRecording() || isPlayingWelcome()}"></canvas>

      @if (!isRecording()){
        <chat-input [chatForm]="chatForm" class="chat__chat-input-wrapper" />
      }

      <!-- @if(!isPlaying() && isStreaming() && !dataChat.inputText()){
          <cancel-button (click)="handleStreamingStop()" [chatForm]="chatForm" />
      } -->

      @if(!isPlaying() && isStreaming()){
          <cancel-button (click)="handleStreamingStop()" [chatForm]="chatForm" />
      }

      @if(!isPlaying() && !isRecording() && !isStreaming() && (dataChat.inputText() || dataChat.selectedImage() || !allowSendAudio())) {
        <send-button [chatForm]="chatForm" />
      } @else if(!isPlaying() && !isStreaming() && allowSendAudio()) {
        <voice-button [chatForm]="chatForm" (actionEmitter)="handleReceivedData($event)" />
      } @else if(isPlaying()){
        <cancel-button (click)="handleStopPlaying()" [chatForm]="chatForm" />
      }

  </form>

  <div class="chat__footer">

    <div class="chat__footer__info">
      <!-- CMAD-231 (WCAG 2.1.1 / 4.1.2): único acceso al aviso de transparencia → <button> real
           (Tab, Enter/Espacio, anunciado como botón con su texto). aria-haspopup anticipa el
           diálogo; aria-expanded refleja si está abierto. El icono es decorativo. -->
      <icon-info aria-hidden="true"></icon-info>
      <button #infoTrigger type="button" class="chat__footer__info__disclaimer"
        (click)="openModal()"
        aria-haspopup="dialog"
        [attr.aria-expanded]="isInfoOpen()">
        @if (dataChat.infoMessageTitleCurrentLang()) {
          {{ dataChat.infoMessageTitleCurrentLang() }}
        } @else {
          {{ 'Considera verificar la información.' | translate }} <b> {{ 'Más información.' | translate }}</b>
        }
      </button>
    </div>

    @if (environment.showPoweredBy) {
      <div (click)="goToiUrban()" class="chat__footer__powered">
        <span class="powered-by">Powered by</span>
        <span class="brand">iURBAN</span>
        <icon-link></icon-link>
      </div>
    }

  </div>